import React from "react"
import { graphql } from "gatsby"
import DefaultVariant from "./photoGalleryVariants/DefaultVariant"
import MasonryVariant from "./photoGalleryVariants/MasonryVariant"
import CarouselVariant from "./photoGalleryVariants/CarouselVariant"

const PhotoGallery = props => {
  const { images, headline, subHeadline } = props

  return (
    images && (
      <section className="mx-auto mb-[110px] max-w-7xl overflow-hidden text-gray-700">
        <div className="container mx-auto py-2 px-3 pt-6 lg:px-10">
          <div className="flex flex-col items-center font-semibold">
            {headline && (
              <h2 className="mx-auto mb-[8px] max-w-md text-center font-neusa text-darkBlue">
                {headline}
              </h2>
            )}

            {subHeadline && (
              <div className="font-subTitle2 mb-[41px]">{subHeadline}</div>
            )}
          </div>

          <GalleryVariant {...props} />
        </div>
      </section>
    )
  )
}

export default PhotoGallery

export const fragment = graphql`
  fragment PhotoGallery on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_PhotoGallery {
      fieldGroupName
      headline
      subHeadline
      galleryVariant
      lightbox
      images {
        defaultGallery {
          link {
            url
          }
          defaultImage {
            altText
            gatsbyImage(
              height: 1920
              width: 1080
              quality: 100
              layout: FULL_WIDTH
              fit: OUTSIDE
              formats: [AUTO, WEBP]
            )
          }
        }
        masonryImage {
          altText
          gatsbyImage(
            width: 1920
            height: 1080
            quality: 100
            layout: FULL_WIDTH
            formats: [AUTO, WEBP]
          )
        }
        carouselImage {
          altText
          gatsbyImage(
            width: 1920
            height: 1080
            layout: FULL_WIDTH
            quality: 100
            formats: [AUTO, WEBP]
          )
        }
      }
    }
  }
`

export const GalleryVariant = props => {
  const { galleryVariant } = props
  switch (galleryVariant) {
    case "carousel":
      return <CarouselVariant {...props} />
    case "masonry":
      return <MasonryVariant {...props} />
    default:
      return <DefaultVariant {...props} />
  }
}
